//Api
import {casFormatAvailable} from 'api/docset'
import {casFormatAvailable as cdcCasFormatAvailable} from 'api/cdc'

//Types
import {Format} from 'types/cas'
import {Format as LinkFormat} from 'types/format'

export const docset = (
  lang: string,
  alias: string, 
  cfr: string, 
  file: string,
  fragment?: string
): string => {
  let href = `/doc/${lang}/${alias}/${cfr}/${file}`

  if (fragment) {
    href = `${href}#${fragment}`
  }

  return href
}

export const docsetHelp = (
  lang: string,
  alias: string,
  cfr: string,
  file: string
): string => {
  return `/doc/${lang}/${alias}/${cfr}/${file}?help`
}

export const docsetImage = (
  alias: string,
  cfr: string,
  file: string,
  language?: string
): string => {
  let src = `./api/docsets/${alias}/${cfr}/content/images/${file}`

  if (language) {
    src = `${src}?locale=${language}`
  }

  return src
}

export const cdc = (
  lang: string,
  alias: string,
  cfr: string,
  docset?: string,
  file?: string,
  fragment?: string
): string => {
  let href = `/doc/${lang}/${alias}/${cfr}`

  if (docset && file) {
    href = `${href}/${docset}/${file}`

    if (fragment) {
      href = `${href}#${fragment}`
    }
  }

  return href
}

export const collection = (
  lang: string,
  alias: string,
  cfr: string,
  cdc?: string,
  docset?: string,
  file?: string,
  fragment?: string
): string => {


  let href = `/doc/${lang}/${alias}/${cfr}`
  if (cdc) {
    href = `${href}/${cdc}`
  }
  if (docset && file) {
    href = `${href}/${docset}/${file}`

    if (fragment) {
      href = `${href}#${fragment}`
    }
  }
  return href
}

export const pdfLink = (lang: string, alias: string, version:string, pref: string, availableCas:Format[]):Promise<string> | undefined => {
  let available = availableCas.find( ac => {return ac.key === pref.toLowerCase()})

  if (available) {
    return casFormatAvailable(alias,version,available.value, LinkFormat.Pdf, lang)
  }

  return undefined
}

export const cdcPdfLink = (lang: string, alias: string, version:string, docset:string, pref: string, availableCas:Format[]):Promise<string> | undefined => {
  let available = availableCas.find( ac => { return ac.key === pref.toLowerCase()})

  if (available) {
    return cdcCasFormatAvailable(alias,version, docset, available.value, LinkFormat.Pdf, lang)
  }

  return undefined
}

export const collectionLink = (
  language: string, 
  collectionAlias: string, 
  collectionCFR: string, 
  cdcAlias: string, 
  docsetAlias: string, 
  page: string
): string => {
  return `/doc/${language}/${collectionAlias}/${collectionCFR}/${cdcAlias}/${docsetAlias}/${page}`
}

export const cdcLink = (
  language: string, 
  cdcAlias: string, 
  cdcCFR: string, 
  docsetAlias: string, 
  page: string
): string => {
  return `/doc/${language}/${cdcAlias}/${cdcCFR}/${docsetAlias}/${page}`
}